import { PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { unitySemanticDarkColorTokens, unitySemanticLightColorTokens } from '../unityTokens';
import { buildPaletteFromMetadata, PaletteTokenMetadata, Token } from './panw-palette/token-metadata';

/** For use strictly within @chronosphereio/chrono-ui */
const checkboxTokens = [
  { propertyPath: 'checkedColor', tokenName: '--semantic-bg-input-inverse' },
  { propertyPath: 'checkedHoverColor', tokenName: '--semantic-bg-input-inverse-hover' },
  { propertyPath: 'disabledColor', tokenName: '--semantic-border-default' },
  { propertyPath: 'uncheckedBorderColor', tokenName: '--semantic-border-bold' },
  { propertyPath: 'uncheckedHoverBorderColor', tokenName: '--semantic-border-inverse' },
] satisfies Token[];

export const checkboxTokenMetadata: PaletteTokenMetadata = {
  componentName: 'checkbox',
  tokens: checkboxTokens,
};

export const checkbox = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['checkbox'] => {
  if (!opts.panwRebrandStubYear) {
    return undefined;
  }

  const tokens = mode === 'light' ? unitySemanticLightColorTokens : unitySemanticDarkColorTokens;
  return buildPaletteFromMetadata(checkboxTokenMetadata.tokens, tokens);
};
